import { ITheme } from '@shared/interfaces';

export const lightTheme: ITheme = {
    bgColorPrimary: '#ffffff',
    bgColorSecondary: '#F3F3F0',
    bgHoverColor: '#E8E8E3',
    textColor: '#000028',
    textColorSecondary: '#66667e',
    petrolGradient: 'linear-gradient(180deg, #00FFB9 0%, #00E6DC 100%)',
    highlightColor: '#009999',
    primaryBtnBG: '#007993',
    primaryBtnBGHover: '#005159',
    primaryBtnText: '#ffffff',
    primaryBtnTextHover: '#ffffff',
    secondaryBtnBG: '#ffffff',
    secondaryBtnBGHover: '#D1FFF2',
    secondaryBtnText: '#007993',
    secondaryBtnTextHover: '#005159',
    tertiaryBtnBG: '#ffffff',
    tertiaryBtnBGHover: '#D1FFF2',
    tertiaryBtnText: '#007993',
    tertiaryBtnTextHover: '#005159',
    actionColor: '#007993',
    actionHoverColor: '#005159',
    actionDisabledColor: '#9999A9',
    labelColor: '#66667e',
    circleInnerColor: 'rgba(163,157,157,0.7)',
    reportDraftColor: '#f49629',
    reportInProgressColor: '#feff35',
    reportCompletedColor: '#78C000',
    ngxEditorBg: '#ebf7f8',
    ngxEditorBgDisabled: '#ebf7f8',
    ngxEditorBorderError: '#FF2640',
    inputBgColor: '#ebf7f8',
    inputBorderColor: '#4C4C68',
    inputActiveBgColor: '#d1fff2',
    inputActiveBorderColor: '#005159',
    inputErrorBG: '#FCCCD7',
    inputTextColorDisabled: 'rgb(153, 153, 169)'
};

export const darkTheme: ITheme = {
    bgColorPrimary: '#000028',
    bgColorSecondary: '#23233C',
    bgHoverColor: '#37374D',
    textColor: '#ffffff',
    textColorSecondary: '#9999A9',
    petrolGradient: 'linear-gradient(180deg, #00FFB9 0%, #00E6DC 100%)',
    highlightColor: '#009999',
    primaryBtnBG: '#00CCCC',
    primaryBtnBGHover: '#00FFB9',
    primaryBtnText: '#000028',
    primaryBtnTextHover: '#000028',
    secondaryBtnBG: '#000028',
    secondaryBtnBGHover: '#001F39',
    secondaryBtnText: '#00CCCC',
    secondaryBtnTextHover: '#00FFB9',
    tertiaryBtnBG: '#000028',
    tertiaryBtnBGHover: '#001F39',
    tertiaryBtnText: '#00CCCC',
    tertiaryBtnTextHover: '#00FFB9',
    actionColor: '#00CCCC',
    actionHoverColor: '#00FFB9',
    actionDisabledColor: '#737389',
    labelColor: '#9999a9',
    circleInnerColor: 'rgba(163,157,157,0.7)',
    reportDraftColor: '#f49629',
    reportInProgressColor: '#feff35',
    reportCompletedColor: '#78C000',
    ngxEditorBg: '#00183B',
    ngxEditorBgDisabled: '#262648',
    ngxEditorBorderError: '#FF2640',
    inputBgColor: '#00183B',
    inputBorderColor: '#B3B3BE',
    inputActiveBgColor: '#001F39',
    inputActiveBorderColor: '#00FFB9',
    inputErrorBG: '#331131',
    inputTextColorDisabled: 'rgb(115, 115, 137)'
};
